/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function GetAllZoneForMaskLoadedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeGetAllZoneForMaskLoadedAction } action:
 *     action de l'application
 * @return { Reducer }
 */
export const GetAllZoneForMaskLoadedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action: actionsTypesFromStore.TypeGetAllZoneForMaskLoadedAction) => {
          switch (action.type) {
            case actions.GetAllZoneForMaskLoadedActionTypes
                .GETALLZONEFORMASKLOADED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;

            case actions.GetAllZoneForMaskLoadedActionTypes
                .GETALLZONEFORMASKLOADED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.GetAllZoneForMaskLoadedActionTypes
                .GETALLZONEFORMASKLOADED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            case actions.GetAllZoneForMaskLoadedActionTypes
                .GETALLZONEFORMASKLOADED_RESET:

              return {
                state: {}
              }

            default:
              return state
              break;
          }
        }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/getallzone/index.ts